import React from 'react'
import { View, StyleSheet } from 'react-native'
import { getOwnBooked, deleteBooking } from '../../../services/api/snakSammen'
import Layout from '../../../constants/Layout'
import { CustomText } from '../../text/StyledText'
import { txt } from '../../../locales/i18n'
import Colors from '../../../constants/Colors'
import { RoundSquareBtn, RoundSquareDeleteBtn } from '../../buttons/StyledButtons'
import { ShadowStyles } from '../../../styles'
import moment from 'moment'
import CustomDialog, { ActionButton, ContentContainer } from '../../dialogs/CustomDialog'
import SurveyPromptDialog, { platforms, shouldShowSurveyPrompt } from '../../dialogs/SurveyPromptDialog'
import { surveyIds } from '../../../services/api/Surveys'
import startVideoSession from '../../../utils/startVideoSession'
import { getConversationId } from '../../../services/api/Inbox'
export default class OwnBookedSessions extends React.Component {
  constructor(props) {
    super(props)

    //sets locale to danish time
    moment.locale([txt('videoChat.locale')])

    this.state = {
      dialogVisible: false,
      currentItem: '',
      surveyPromptVisible: false,
    }
  }

  // https://react-native-elements.github.io/react-native-elements/docs/listitem.html
  keyExtractor = (item, index) => index.toString()

  formatUnixDate(date) {
    var d = moment(date).format('dddd [d.] DD/MM [kl.] HH:mm')
    return d.charAt(0).toUpperCase() + d.substr(1)
  }

  async handleSendMessage(item) {
    const { booker_id, id } = item
    if (!booker_id || !id) return
	
    const conversationId = await getConversationId({
      vsSessionId: id,
      receiverId: booker_id,
    })

    if (conversationId) this.props.navigateToConversation(conversationId)
    else this.props.navigateToNewConversation(booker_id, id)
  }

  _showDialog = () => this.setState({ dialogVisible: true })
  _hideDialog = () => this.setState({ dialogVisible: false })

  triggerSurveyPrompt = async () => {
    const show = await shouldShowSurveyPrompt(surveyIds.snaksammenVolunteer)
    if (show) {
      this.setState({ surveyPromptVisible: true })
    }
  }

  async handleStartPress(item) {
    await startVideoSession(item.room_key, item.vonage_session_id, 'snaksammen')
    // await this.triggerSurveyPrompt()
  }

  render() {
    return (
      <View style={styles.container}>
        {this.props.ownBookedSessions.length === 0 ? (
          <View>
            <CustomText font="largeBold" style={styles.titleBold} accessibilityRole="header" aria-level={2}>
              {txt('videoChat.ownBookedSessions')}
            </CustomText>
            <CustomText style={styles.noSession}>{txt('videoChat.noOwnBookedSessions')}</CustomText>
          </View>
        ) : (
          <CustomText font="largeBold" style={styles.titleBold} accessibilityRole="header" aria-level={2}>
            {txt('videoChat.ownBookedSessions')}
          </CustomText>
        )}

        {this.props.ownBookedSessions.map((item, key) => {
          var date = this.formatUnixDate(item.start_date)
          return (
            <View key={key} style={styles.sessionContainer}>
              <View style={styles.textContainer}>
                <CustomText font="small">{date}</CustomText>
                <CustomText font="small">
                  {txt('videoChat.duration')}:{' '}
                  {(new Date(item.end_date).getTime() - new Date(item.start_date).getTime()) / 1000 / 60}
                  {' min.'}
                </CustomText>
                <CustomText font="small">
                  {txt('videoChat.bookedBy')}: {item.username}
                </CustomText>
              </View>
              <View style={styles.buttonsContainer}>
                <View style={styles.buttonStartContainer}>
                  <RoundSquareBtn
                    title={txt('videoChat.start')}
                    onPress={() => this.handleStartPress(item)}
                    style={styles.button}
                  />
                </View>
                <View style={styles.buttonConversationContainer}>
                  <RoundSquareBtn
                    title={txt('conversations.messageSend')}
                    onPress={() => this.handleSendMessage(item)}
                    style={styles.button}
                  />
                </View>
                <View style={styles.buttonCancelContainer}>
                  <RoundSquareDeleteBtn
                    title={txt('videoChat.cancel')}
                    style={styles.button}
                    onPress={() => {
                      this.setState({ currentItem: item })
                      this._showDialog()
                    }}
                  />
                </View>
              </View>
            </View>
          )
        })}
        <CustomDialog visible={this.state.dialogVisible}>
          <ContentContainer>
            <CustomText>{txt('videoChat.deleteDialogText')}</CustomText>
          </ContentContainer>
          <ActionButton
            onPress={async () => {
              await deleteBooking(this.state.currentItem.id)
              await this.props.reloadAll()
              this._hideDialog()
            }}
          >
            {txt('videoChat.dialogYes')}
          </ActionButton>
          <ActionButton onPress={this._hideDialog}>{txt('videoChat.dialogNo')}</ActionButton>
        </CustomDialog>

        <SurveyPromptDialog
          visible={this.state.surveyPromptVisible}
          surveyId={surveyIds.snaksammenVolunteer}
          platform={platforms.SnakSammen}
          surveyLink={'https://www.survey-xact.dk/LinkCollector?key=UY3XFQ9TS531'}
          onDismiss={() => this.setState({ surveyPromptVisible: false })}
          volunteer
        />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  buttonCancelContainer: {
    flex: 1,
    justifyContent: 'center',
  },
  buttonConversationContainer: {
    flex: 1,
    justifyContent: 'center',
    paddingBottom: Layout.isSmallDevice ? 10 : 0,
    paddingRight: 2,
  },
  buttonStartContainer: {
    flex: 1,
    justifyContent: 'center',
    paddingBottom: Layout.isSmallDevice ? 10 : 0,
    paddingRight: 2,
  },
  buttonsContainer: {
    flex: Layout.isSmallDevice ? 1 : 2,
    flexDirection: Layout.isSmallDevice ? 'column' : 'row',
    justifyContent: 'space-evenly',
  },
  button: { paddingHorizontal: 0 },
  container: {
    backgroundColor: Colors.background,
    margin: 10,
    zIndex: -1,
  },
  noSession: {
    color: Colors.inactive,
    marginTop: 10,
    textAlign: 'center',
  },
  sessionContainer: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    flexDirection: 'row',
    marginTop: 10,
    padding: 10,
    ...ShadowStyles.shadowInputs,
  },
  textContainer: { flex: 2, justifyContent: 'center' },
  titleBold: {
    color: Colors.text,
    textAlign: 'center',
  },
})
